import { Component, OnInit } from "@angular/core";
import { ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { NotificationsService } from "@services/notifications.service";

export interface DateDialogOptions {
  text: string;
  action: string;
  status: "secondary" | "primary";
}

@Component({
  selector: "app-date-modal",
  templateUrl: "./date-modal.component.html",
  styleUrls: ["./date-modal.component.scss"],
})
export class DateModalComponent implements OnInit {
  public date;
  public tillDate = new Date();
  public fromDate;
  constructor(
    private dialogRef: ScaffoldDialogRef,
    private notifications: NotificationsService
  ) {}
  ngOnInit(): void {}

  get useRange(): boolean {
    return this["data"]?.useRange || false;
  }

  get size(): string {
    return this["data"]?.size || "";
  }
  get title(): string {
    return this["data"]?.title || "";
  }
  get text(): string {
    return this["data"]?.text || "";
  }

  get declineMessage(): string {
    return this["data"]?.declineMessage;
  }

  get confirmMessage(): string {
    return this["data"]?.confirmMessage;
  }

  get fit(): boolean {
    return this["data"]?.fit || this["data"]?.fit === false
      ? this["data"]?.fit
      : true;
  }
  get fullHeight(): boolean {
    return this["data"]?.fullHeight || this["data"]?.fullHeight === false
      ? this["data"]?.fullHeight
      : false;
  }

  get showCloseButton(): boolean {
    return this["data"]?.showCloseButton || true;
  }

  handleDateRangeSubmit() {
    // if not valid, avoid submitting
    // if (!this.isValidDate(this.fromDate)||!this.isValidDate(this.tillDate)) {
    //   return this.notifications.popNotification("", "Invalid Date");
    // }

    this.dialogRef.close({ from: this.fromDate, till: this.tillDate });
  }

  handleDateSubmit() {
    // if not valid, avoid submitting
    if (!this.isValidDate(this.date)) {
      return this.notifications.popNotification("", "Invalid Date");
    }
    this.dialogRef.close(this.date);
  }

  handleClick(provideData?) {
    if (!provideData) return this.dialogRef.close();
    this.useRange ? this.handleDateRangeSubmit() : this.handleDateSubmit();
  }

  updateTillDate($event) {
    if (!$event) {
      this.tillDate = null;
      return;
    }
    
    const date = new Date($event);
    if (this.isValidDate(date)) {
      // Set to start of day
      
      date.setHours(23, 59, 59, 999);
      this.tillDate = date;
    } else {
      this.tillDate = null;
    }
  }

  updateFromDate($event) {
    if (!$event) {
      this.fromDate = null;
      return;
    }
    
    const date = new Date($event);
    if (this.isValidDate(date)) {
      // Set to end of day
      date.setHours(0, 0, 0, 0);
      this.fromDate = date;
    } else {
      this.fromDate = null;
    }
  }

  updateDate($event) {
    if (!$event) {
      this.date = null;
      return;
    }
    
    const date = new Date($event);
    if (this.isValidDate(date)) {
      // Set to start of day
      date.setHours(0, 0, 0, 0);
      this.date = date;
    } else {
      this.date = null;
    }
  }

  // Helper method to check if a date is valid
  isValidDate(date: any): boolean {
    return date instanceof Date && !isNaN(date.getTime());
  }
}
